import React, { useEffect } from "react";
import "./GlitchTheme.css";
import GalaxyBackground from "./GalaxyBackground";

const photos = [
  {
    id: 1,
    filename: "REC_SESSION_01.CR2",
    date: "14.10.2025",
    desc: "GRAVAÇÃO DE VOZ",
    delay: "0.1s",
  },
  {
    id: 2,
    filename: "ALBUM_COVER_FINAL.PNG",
    date: "10.03.2026",
    desc: "RENDERIZAÇÃO DA ARTE",
    delay: "0.2s",
  },
  {
    id: 3,
    filename: "STUDIO_NIGHT_LATE.JPG",
    date: "22.01.2026",
    desc: "MIXAGEM MADRUGADA",
    delay: "0.3s",
  },
  {
    id: 4,
    filename: "PROMO_SHOOT_B.RAW",
    date: "05.02.2026",
    desc: "FOTOS DE DIVULGAÇÃO",
    delay: "0.4s",
  },
  {
    id: 5,
    filename: "LIVE_REHEARSAL.MP4",
    date: "12.04.2026",
    desc: "PREPARAÇÃO PRO SHOW",
    delay: "0.5s",
  },
  {
    id: 6,
    filename: "GLITCH_ASSETS_V2.PSD",
    date: "01.03.2026",
    desc: "ARQUIVOS VISUAIS",
    delay: "0.6s",
  },
];

const Fotos: React.FC = () => {
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      document.documentElement.style.setProperty(
        "--mouse-x",
        `${(e.clientX / window.innerWidth) * 100}%`
      );
      document.documentElement.style.setProperty(
        "--mouse-y",
        `${(e.clientY / window.innerHeight) * 100}%`
      );
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="wonder-page wonder-galaxy galaxy-subpage">
      <GalaxyBackground />

      <div className="galaxy-subpage-content">
        <header className="glitch-wrapper" style={{ marginBottom: "2rem" }}>
          <h1 className="glitch-title galaxy-title-text" data-text="GALERIA">
            GALERIA
          </h1>
          <p className="galaxy-subtitle blur-text-reveal">
            BASTIDORES E ARQUIVOS VISUAIS // ACESSO AO SISTEMA
          </p>
        </header>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(min(320px, 100%), 1fr))",
            gap: "1.5rem",
            padding: "0 1rem",
            maxWidth: "1200px",
            margin: "4rem auto 0 auto",
          }}
        >
          {photos.map((photo) => (
            <div
              key={photo.id}
              className="card-hover photo-card galaxy-photo-card"
              style={{
                height: "clamp(260px, 45vw, 320px)",
                border: "1px solid rgba(180, 100, 255, 0.15)",
                position: "relative",
                animation: `fadeInUp 0.6s ease-out ${photo.delay} forwards`,
                opacity: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                cursor: "pointer",
                background: "rgba(20, 5, 40, 0.4)",
                backdropFilter: "blur(10px)",
                backgroundImage:
                  "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(180, 100, 255, 0.03) 2px, rgba(180, 100, 255, 0.03) 4px)",
              }}
            >
              {/* Header do card */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  padding: "1rem",
                  boxSizing: "border-box",
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "0.7rem",
                  letterSpacing: "1px",
                  fontFamily: '"Space Mono", monospace',
                  zIndex: 2,
                  background:
                    "linear-gradient(180deg, rgba(12,2,28,0.9) 0%, transparent 100%)",
                }}
              >
                <span style={{ color: "#c87fff" }}>&gt; {photo.filename}</span>
                <span style={{ color: "rgba(200,160,255,0.4)" }}>
                  {photo.date}
                </span>
              </div>

              {/* Placeholder */}
              <span
                style={{
                  color: "rgba(180,120,255,0.2)",
                  fontSize: "0.9rem",
                  letterSpacing: "3px",
                }}
              >
                [ ARQUIVO_{photo.id} ]
              </span>

              {/* Footer do card */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  padding: "1rem",
                  boxSizing: "border-box",
                  textAlign: "left",
                  color: "rgba(200,160,255,0.5)",
                  fontSize: "0.8rem",
                  letterSpacing: "1px",
                  borderTop: "1px solid rgba(180,100,255,0.1)",
                  background: "rgba(12,2,28,0.9)",
                  zIndex: 2,
                }}
              >
                DESC: {photo.desc}
              </div>

              {/* Hover overlay */}
              <div
                className="photo-overlay"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(160, 60, 255, 0.12)",
                  backdropFilter: "blur(2px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0,
                  transition: "all 0.3s ease",
                  zIndex: 3,
                }}
                onMouseOver={(e) => (e.currentTarget.style.opacity = "1")}
                onMouseOut={(e) => (e.currentTarget.style.opacity = "0")}
              >
                <button
                  style={{
                    background: "transparent",
                    color: "#e0b8ff",
                    border: "1px solid rgba(200,120,255,0.6)",
                    padding: "0.8rem 2rem",
                    fontFamily: '"Space Mono", monospace',
                    fontWeight: "bold",
                    fontSize: "0.85rem",
                    letterSpacing: "3px",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    boxShadow: "0 0 20px rgba(180,80,255,0.3)",
                  }}
                >
                  [ ABRIR ]
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fotos;
